import React from 'react';
import { View, StyleSheet } from 'react-native';

import LessonMenuOverlay from './LessonMenuOverlay';

/**
 * Wrapper component for lesson overlay navigation.
 * For now this simply renders the LessonMenuOverlay directly.
 * Can be extended to support navigation stack if needed.
 */
export default function LessonStackOverlay({ onClose, hide = false }) {
  React.useEffect(() => {
    console.log('[LessonStackOverlay] mount. hide =', hide);
    return () => console.log('[LessonStackOverlay] unmount');
  }, [hide]);

  // When hidden, unmount entirely so nothing covers Unity
  if (hide) return null;

  return (
    <View style={styles.wrapper} pointerEvents="box-none">
      <LessonMenuOverlay onClose={onClose} />
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    backgroundColor: 'transparent',
  },
});
